export const RegentsExamPrepStatuses = {
  NO_PREP: 'No Prep',
  ADD_PREP: 'Additional Prep Only',
  COURSE_ADD_PREP: 'Course & Additional Prep',
  COURSE_PASSING: 'Only Course - Passing',
  COURSE_FAILING: 'Only Course - Failing/Borderline',
};
